export class AsyncUtil {
    static delay(ms: number, abortSignal?: AbortSignal) {
        return new Promise<void>(resolve => {
            const timeout = setTimeout(resolve, ms)
            if (abortSignal) {
                abortSignal.addEventListener('abort', () => {
                    clearTimeout(timeout)
                    resolve() // just resolve early (don't throw)
                }, { once: true })
            }
        })
    }

    static async atLeast<T>(ms: number, promise: T | Promise<T>) {
        await Promise.all([AsyncUtil.delay(ms), promise])
        return await promise
    }
}
